import {Component}       from '@angular/core';
import {LoginService}     from './service/login.service';
import {OperatorLoginComponent} from './login/operatorLogin.component';
import {ClientLoginComponent} from './login/clientLogin.component';
import {MODAL_DIRECTIVES, BS_VIEW_PROVIDERS} from 'ng2-bootstrap/ng2-bootstrap';
import {
    FORM_DIRECTIVES,
    FORM_PROVIDERS,
    REACTIVE_FORM_DIRECTIVES,
    FormControl,
    FormGroup,
    Validators,
    FormArray
} from '@angular/forms';
import {DEFAULT_ERROR_MESSAGES, EMAIL_VALIDATOR} from "./validators/validators";
import {ContactInfo} from './domain/contactInfo';
import {ClientService} from './service/client.service';

@Component({
    selector: 'index',
    template: require('./index.component.html'),
    styles: [require('./index.component.css')],
    directives: [
        OperatorLoginComponent,
        ClientLoginComponent,
        MODAL_DIRECTIVES,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES
    ],
    viewProviders: [BS_VIEW_PROVIDERS],
    providers: [FORM_PROVIDERS]
})
export class IndexComponent {

    public itemMenuSelected:String;
    public contactInfo:ContactInfo;

    public loading:boolean;
    public successMessage:string;
    public errorMessage:string;
    public errorMessages:any;

    public form:FormGroup;

    constructor(private clientService:ClientService) {
        this.init();
    }

    private init():void {
        this.itemMenuSelected = 'home';
        this.contactInfo = new ContactInfo();

        this.loading = false;
        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        let group:any = {};
        group['name'] = new FormControl('', [Validators.required]);
        group['surname'] = new FormControl('', [Validators.required]);
        group['phone'] = new FormControl('', [Validators.required]);
        group['email'] = new FormControl('', [EMAIL_VALIDATOR]);
        group['comments'] = new FormControl();
        this.form = new FormGroup(group);
    }

    public sendContactInfo():void {
        this.loading = true;
        this.clientService.sendContactInfo(this.contactInfo).subscribe(
            () => {
                this.loading = false;
                this.successMessage = 'La consulta se envió con éxito.';
                this.contactInfo = new ContactInfo();
            },
            () => {
                this.bindError('Ocurrió un error al enviar la consulta.');
            });
    }

    private bindError(messageError:string):void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/index.component.ts
 **/